import React, { useState, useEffect } from 'react';
import { Grid, Typography, Box, Icon, Card, CardContent } from '@mui/material';
import MKTypography from 'components/MKTypography';
import Adv1 from 'assets/images/advertisement/adv_1.gif';
import Adv2 from 'assets/images/advertisement/adv_2.gif';
import Adv3 from 'assets/images/advertisement/adv_3.gif';
import Adv4 from 'assets/images/advertisement/adv_4.gif';
import Adv5 from 'assets/images/advertisement/adv_5.gif';
import Adv6 from 'assets/images/advertisement/adv_6.gif';
import Adv7 from 'assets/images/advertisement/adv_7.gif';
import Adv8 from 'assets/images/advertisement/adv_8.gif';
import Adv9 from 'assets/images/advertisement/adv_9.gif';

const Page = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [imageData, setImageData] = useState([]);
  const images = [Adv1, Adv2, Adv3, Adv4, Adv5, Adv6, Adv7, Adv8, Adv9];
  const perSlide = 3;

  const totalSlides = Math.ceil(images.length / perSlide);

  const handlePrevSlide = () => {
    console.log("totalSlides", totalSlides);
    setCurrentSlide((prevSlide) => (prevSlide === 0 ? totalSlides - 1 : prevSlide - 1));
  };

  const handleNextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide === totalSlides - 1 ? 0 : prevSlide + 1));
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      handleNextSlide();
    }, 5000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    const preloadImages = images.map((imageSrc) => {
      const img = new Image();
      img.src = imageSrc;
      return img;
    });
  }, []);

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/ad-images-apiview/`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('token'),
      },
    })
      .then((resp) => resp.json())
      .then((data) => {
        if (!data.detail) {
          setImageData(data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  console.log("Image Data", imageData);

  const renderPictureCards = () => {
    const startIndex = currentSlide * perSlide;
    const endIndex = startIndex + perSlide;
    const slideToShow = images.slice(startIndex, endIndex);

    if (startIndex + perSlide > images.length) {
      const remainingImages = perSlide - slideToShow.length;
      const additionalImages = images.slice(0, remainingImages);
      slideToShow.push(...additionalImages);
    }

    return slideToShow.map((image, index) => {
      const imageName = `Adv${index + 1}`;
      const imageDataForImage = imageData.find((data) => data.imageName === imageName);

      if (!imageDataForImage) {
        return null;
      }

      const { imageURL } = imageDataForImage;

      return (
        <div key={index} style={{ width: '100%', margin: '15px' }}>
          <CardContent
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              height: '100%',
            }}
          >
            <a
              href={imageURL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src={image}
                alt={`Image ${index}`}
                style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '15px' }}
                onClick={() => window.open(imageURL, '_blank')}
              />
            </a>
          </CardContent>
        </div>
      );
    });
  };


  return (
    <>
      <Grid container spacing={2} style={{ marginTop: '30px', marginBottom: '30px' }}>
        <Grid item xs={1}>
          <Icon style={{ marginTop: '170px', cursor: 'pointer' }} onClick={handlePrevSlide}>
            keyboard_arrow_left
          </Icon>
        </Grid>
        <Grid item xs={10}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            {renderPictureCards()}
          </Box>
        </Grid>
        <Grid item xs={1}>
          <Box display="flex" justifyContent="flex-end" alignItems="center">
            <Icon style={{ marginTop: '170px' }} onClick={handleNextSlide}>keyboard_arrow_right</Icon>
          </Box>
        </Grid>
      </Grid>
    </>
  );
};

export default Page;
